import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IonContent } from "@ionic/angular";
import { FormControlsHelper } from "../helpers/formControls.helper";
import { LoggerService } from "../services/logs/logger.service";

@Component({
    template: "",
})
export abstract class FormValidationBaseComponent implements OnInit, OnDestroy {
    @ViewChild(IonContent, { read: ElementRef }) viewport: ElementRef;

    previousErrors = "";
    interval: any;

    formGroup: FormGroup = null;

    protected constructor(protected logger: LoggerService) {
    }

    public ngOnInit() {
        this.interval = setInterval(() => {
            let formErrors = FormControlsHelper.getFormErrors(this.formGroup);
            let errors = "";
            if (formErrors) {
                errors = JSON.stringify(formErrors, null, "  ");
            } else {
                errors = "No errors";
            }

            if (errors != this.previousErrors) {
                this.previousErrors = errors;
                this.logger.warn(this.constructor.name, "Form controls errors : " + errors);
            }
        }, 1000);
    }

    public ngOnDestroy(): void {
        clearInterval(this.interval);
    }

    public isFieldInvalid(field: string) {
        return !this.formGroup.get(field).valid && this.formGroup.get(field).touched;
    }

    public fieldHasError(field: string, error: string) {
        return this.formGroup.get(field).hasError(error) && this.formGroup.get(field).touched;
    }
}
